<template>
    <v-container v-if="loadSkeleton">
        <SkeletonLoader ruta="turnos" tipo="table-heading, card"></SkeletonLoader>
    </v-container>
    <v-container v-else>
        <v-card flat>
            <v-card-title class="font-weight-bold text-h5">
                <v-icon color="primary" class="mr-3" size="34">mdi-scale-balance</v-icon>
                Pericias
            </v-card-title>
            <v-card class="rounded-0" outlined>
                <v-card-title class="d-flex flex-row font-weight-bold primary--text text-h5">
                    Generar boleta para Pericias
                </v-card-title>
                <v-card-text>
                    <ValidationObserver ref="obs" v-slot="{ invalid }">
                        <v-form name="formPericias" @submit.prevent="descargar">
                            <v-row class="d-flex flex-row">
                                <v-col cols="12" md="3">
                                    <v-text-field class="custom-label" append-icon="mdi-account" :value="user.nroafi"
                                        outlineed type="number" readonly label="Nro. Afiliado" hide-spin-buttons
                                        label-color="primary"></v-text-field>
                                </v-col>
                                <v-col cols="12" md="9" class="justify-end">
                                    <ValidationProvider rules="required|max:10|fechafutura" v-slot="v">
                                        <v-text-field v-model="fecpago" label="Fecha de pago:" type="date"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field @input="autos = autos.toUpperCase()" v-model="autos" label="Autos"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12">
                                    <ValidationProvider rules="required" v-slot="v">
                                        <v-text-field v-model="formattedValue" type="text" @input="formatValue"
                                            maxlength="15" :rules="[validateDecimal]" :error-messages="v.errors[0]"
                                            label="Total regulado" prefix="$"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12" class="d-flex justify-end">
                                    <v-btn type="descargar" elevation="0" class="pa-5" :disabled="invalid"
                                        color="primary">
                                        <v-icon class="mr-2">mdi-download</v-icon>
                                        Descargar
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </ValidationObserver>
                </v-card-text>
            </v-card>
        </v-card>
    </v-container>
</template>

<script>

import SkeletonLoader from '@/components/alerts/SkeletonLoader.vue';
import { mapGetters, mapActions } from 'vuex'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
    components: {
        ValidationObserver,
        ValidationProvider,
        SkeletonLoader
    },
    data() {
        return {
            title: '',
            autos: '',
            importe: '',
            nroafi: '',
            fecpago: '',

            value: '',
            formattedValue: ''
        }
    },
    methods: {
        ...mapActions('boletas', ['descargarPericia']),
        formatValue(value) {
            // Remover cualquier carácter no numérico excepto la coma
            let newValue = value.replace(/[^0-9,]/g, '');

            // Si el valor contiene más de una coma, elimina las extras
            const parts = newValue.split(',');
            if (parts.length > 2) {
                newValue = parts[0] + ',' + parts[1].substring(0, 2); // limitar a dos decimales
            }

            this.formattedValue = newValue;
        },
        validateDecimal(value) {
            // Validar que el valor sea un número decimal con coma como separador
            const regex = /^[0-9]+(,[0-9]{1,2})?$/;
            return regex.test(value) || 'Ingrese un valor válido (ej: 35000,50)';
        },
        descargar() {
            const obj = {
                nroafilia: this.user.nroafi,
                autos: this.autos,
                totregulado: this.formattedValue,
                fpago: this.fecpago,
                tpapo: 5,
                token: this.token,
            }
            this.descargarPericia(obj)
        }
    },
    mounted() {
    },
    computed: {
        ...mapGetters('auth', ['user', 'isAuthenticated', 'loadSkeleton', 'token']),
    }
}
</script>

<style>
.custom-label .v-label .custom-label .v-label--active {
    color: primary !important;
    font-size: 20px !important;
    font-weight: bold !important;
}
</style>
